export function generateView(transactions) {

    let myCurrentBalanceView = '';

    transactions.forEach(transaction => {

        console.log(transaction.created_at);
        myCurrentBalanceView = myCurrentBalanceView + `<div class="currentUserRowDetail">
                    <span>${transaction.username}</span>
                    <span>${transaction.created_at.split(' ')[0].split('-')[1]}-${transaction.created_at.split(' ')[0].split('-')[2]} ${transaction.created_at.split(' ')[1].split(':')[0]}:${transaction.created_at.split(' ')[1].split(':')[1]}</span>
                    <span class="currentBalanceAmount ${(parseFloat(transaction.total_amount).toFixed(2)) <= 0 ?'red' : ''}">${parseFloat(transaction.total_amount).toFixed(2)}</span>
                </div>`
    });


    return myCurrentBalanceView;
}
